import { render, staticRenderFns } from "./WithdrawalSettings.vue?vue&type=template&id=3611109e"
import script from "./WithdrawalSettings.vue?vue&type=script&lang=js"
export * from "./WithdrawalSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports